export default "__VITE_ASSET__tfRZEgNb__"